// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2mmAD","dragIcon":"SortableItem_dragIcon__k7rrY","disabled":"SortableItem_disabled__Pi_hD"};